/**
 * Normalizes the `message` field of a NestJS error body for display.
 * ValidationPipe returns `message: string[]` for 400 validation errors
 * (which MatSnackBar would otherwise render comma-coerced), other
 * HttpExceptions return `message: string`.
 */
export function normalizeBackendMessage(message: unknown): string | null {
  if (Array.isArray(message) && message.length > 0) {
    return message.join('; ');
  }
  if (typeof message === 'string' && message !== '') {
    return message;
  }
  return null;
}
